export default "__VITE_ASSET__B534zF0U__"